import UserNewspaper from './UserNewspaper'

export default UserNewspaper
